import { render, staticRenderFns } from "./PaymentsGetnet.vue?vue&type=template&id=036bbb39&scoped=true&"
import script from "./PaymentsGetnet.vue?vue&type=script&lang=js&"
export * from "./PaymentsGetnet.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsGetnet.vue?vue&type=style&index=0&id=036bbb39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036bbb39",
  null
  
)

export default component.exports